<template>
    <ChooseBar/>
</template>

<script>
// @ is an alias to /src
import ChooseBar from 'place/home/chooseBar.vue'
export default {
  name: 'home',
  components: {
    ChooseBar
  }
}
</script>
